/**
 * Load javascript, allow to use the cached objects
 * @param {string} url
 * @returns {$.Deferred}
 */
///////////////////////////////////		
// the jQuery $.cachedScript() https://api.jquery.com/jQuery.getScript/
// does'nt work in Firefox since jQuery3.
// The FF debugger don't shows the loaded JS files
// 
//	$.cachedScript = function( url, options ) {
//		
//		// Allow user to set any option except for dataType, cache, and url
//		options = $.extend( options || {}, {
//			dataType: "script",
//			cache: true,
//			url: url
//		});
//		// Return the jqXHR object so we can chain callbacks
//		return jQuery.ajax( options );
///////////////////////////////////		

$.cachedScript = function (url) {

'use strict';


	var deferred = $.Deferred();
	var sc = document.createElement('script');
	sc.type = 'text/javascript';
	if (sc.readyState) {
		sc.onreadystatechange = function () {
			console.log(url, sc.readyState);
			if (sc.readyState === 'loaded' || sc.readyState === 'complete') {
				sc.onreadystatechange = null;
				deferred.resolve();
			}
		};
	} else {
		sc.onload = function () {
			deferred.resolve();
		};
		sc.onerror = function (error, source, lineno, colno, message) {
			console.error('Error loading', url, message, error, lineno, ':', colno);
			deferred.reject(error);
		};
	}
	sc.src = url;
	document.getElementsByTagName('head')[0].appendChild(sc);

	return deferred;
};